/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Due_Date_Clear_OptionInputs */



/**
* | output |
* | --- |
* | "Clear due date" |
*
* @param {Explorer_Info_Due_Date_Clear_OptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_due_date_clear_option = /** @type {((inputs?: Explorer_Info_Due_Date_Clear_OptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Due_Date_Clear_OptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Clear due date")
	if (locale === "de") return /** @type {LocalizedString} */ ("Clear due date")
	if (locale === "it") return /** @type {LocalizedString} */ ("Clear due date")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Clear due date")
	if (locale === "es") return /** @type {LocalizedString} */ ("Clear due date")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Clear due date")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Clear due date")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Clear due date")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Clear due date")
	return /** @type {LocalizedString} */ ("Clear due date")
});